import { IMDSButtonProps } from "./button.h";
import { StyledButton } from "./button.style";

/**
 * Basic button component
 */
export function MDSButton(props: IMDSButtonProps) {
  return <StyledButton data-mds-name="button" {...props} />;
}
